import { render, staticRenderFns } from "./MyPackage.vue?vue&type=template&id=2f1d54d7&"
import script from "./MyPackage.vue?vue&type=script&lang=js&"
export * from "./MyPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports